import { useRef } from 'react';
export const useTrackedRef = value => {
  const ref = useRef(value);
  ref.current = value;
  return ref;
};